import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import Loading from "../Loading/Loading";
import { AlertError } from "../StandardAlerts/StandardAlerts";
import { BootstrapColorsRGBAString } from "../../../Services/Shared/BootstrapColor.service";
export const Loaders = {
    default: (options = {}) => ({ comp, isLoading }) => isLoading ? (_jsx(Loading, { size: options.loaderSize || "2x", className: options.noLoadingMargin ? "" : "my-3", isCentered: true })) : (comp),
    hideLoader: () => ({ comp, isLoading }) => isLoading ? null : comp,
    overlay: (options = {}) => ({ comp, isLoading }) => comp == null ? (_jsx(Loading, { size: options.loaderSize || "2x", className: "my-3", isCentered: true })) : (_jsxs("div", { style: { position: "relative", height: "100%" }, children: [isLoading && (_jsx("div", { style: {
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    backgroundColor: BootstrapColorsRGBAString.Light(0.6),
                    zIndex: 1020,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }, children: _jsx(Loading, { size: options.loaderSize || "3x", style: { color: BootstrapColorsRGBAString.Dark(0.6) } }) })), comp] })),
    skeleton: (options = {}) => ({ comp, isLoading }) => isLoading ? (_jsx("div", { className: classNames("skeleton", !options.loaderHeight && "h-100"), style: options.loaderHeight ? { height: options.loaderHeight } : undefined })) : (comp),
};
const ServiceResult = (props) => {
    var _a, _b;
    const weHaveData = props.considerEmptyArrayAsNoData
        ? Array.isArray(props.state.data) && !!((_a = props.state.data) === null || _a === void 0 ? void 0 : _a.length)
        : props.state.data != null;
    let renderedComponent = null;
    if (weHaveData || props.stillRenderChildWhenNoData) {
        renderedComponent =
            typeof props.children === "function"
                ? props.children(props.state.data)
                : props.children;
    }
    const loader = (_b = props.loader) !== null && _b !== void 0 ? _b : Loaders.default();
    if (props.state.isLoading) {
        return loader({
            comp: renderedComponent,
            isLoading: true,
        });
    }
    if (props.state.hasError) {
        return (_jsx(AlertError, { className: props.errorClassName, message: props.errorMessage || "There was an error", detail: props.state.errorMessage }));
    }
    if (props.state.wasSuccessful &&
        !weHaveData &&
        !props.stillRenderChildWhenNoData) {
        return props.noDataComponent ? props.noDataComponent : (_jsx("div", { className: "text-center mt-2", children: "No data." }));
    }
    if (!weHaveData && !props.stillRenderChildWhenNoData) {
        return props.initialComponent || null;
    }
    return loader({ comp: renderedComponent, isLoading: false });
};
export default ServiceResult;
